var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      attrs: { drawer: _vm.drawer, withHeader: false, size: 744 },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "view" },
        [
          _c(
            "div",
            { staticClass: "content scrollbar" },
            [
              _c("p", { staticClass: "title" }, [
                _c("span", [_vm._v("填报ISF")]),
                _c(
                  "span",
                  {
                    staticClass: "tpl",
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible2 = true
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/tpl.png"),
                        width: "20px",
                      },
                    }),
                    _vm._v(" 使用模板 "),
                  ]
                ),
              ]),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: {
                    model: _vm.isf,
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "OnBoard Date(开船日期)",
                            prop: "onBoardDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "160px" },
                            attrs: {
                              type: "date",
                              placeholder: "选择日期",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.isf.onBoardDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.isf, "onBoardDate", $$v)
                              },
                              expression: "isf.onBoardDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Bill Number Type(提单类型)",
                            prop: "classification",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "228px" },
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.isf.classification,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "classification", $$v)
                                },
                                expression: "isf.classification",
                              },
                            },
                            _vm._l(
                              _vm.config.billNumberTypeOptions,
                              function (item, $index) {
                                return _c("el-option", {
                                  key: $index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户", prop: "companyId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "228px" },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择客户",
                              },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.isf.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "companyId", $$v)
                                },
                                expression: "isf.companyId",
                              },
                            },
                            _vm._l(_vm.companyList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "AMS SCAC(AMS代码)",
                            prop: "amsscac",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: { maxlength: "4" },
                            model: {
                              value: _vm.isf.amsscac,
                              callback: function ($$v) {
                                _vm.$set(_vm.isf, "amsscac", $$v)
                              },
                              expression: "isf.amsscac",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "AMS No.(AMS号码)",
                            prop: "amsblNumber",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "228px" },
                            attrs: { maxlength: "12" },
                            model: {
                              value: _vm.isf.amsblNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.isf, "amsblNumber", $$v)
                              },
                              expression: "isf.amsblNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Importer Bond Type(磅的类型)",
                            prop: "bondType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "228px" },
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.isf.bondType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "bondType", $$v)
                                },
                                expression: "isf.bondType",
                              },
                            },
                            _vm._l(
                              _vm.config.bondTypeOptions,
                              function (item, $index) {
                                return _c("el-option", {
                                  key: $index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.isf.classification === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "主提单号",
                                prop: "mblNo",
                                required: "",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "160px" },
                                model: {
                                  value: _vm.isf.mblNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.isf, "mblNo", $$v)
                                  },
                                  expression: "isf.mblNo",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "consigneeName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Consignee(收货人)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.consigneeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "consigneeName", $$v)
                                },
                                expression: "isf.consigneeName",
                              },
                            },
                            _vm._l(
                              _vm.consigneeOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "importerName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Importer(进口商)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.importerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "importerName", $$v)
                                },
                                expression: "isf.importerName",
                              },
                            },
                            _vm._l(_vm.importerOptions, function (item, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: { label: item.name, value: item.name },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492a6",
                                        "font-size": "13px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              item?.address
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              item?.cityAddress
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              item?.provinceEnName
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatStatusAddress")(
                                              item?.countryName
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            item?.postcode ? item?.postcode : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "buyerName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Buyer(买家)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.buyerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "buyerName", $$v)
                                },
                                expression: "isf.buyerName",
                              },
                            },
                            _vm._l(
                              _vm.buyerNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "sellingName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Selling Party(卖家)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.sellingName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "sellingName", $$v)
                                },
                                expression: "isf.sellingName",
                              },
                            },
                            _vm._l(
                              _vm.sellingNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "shipToPartyName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Ship To Party(通知人)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.shipToPartyName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "shipToPartyName", $$v)
                                },
                                expression: "isf.shipToPartyName",
                              },
                            },
                            _vm._l(
                              _vm.shipToPartyNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "manufacturerName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Manufacture(制造商)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.manufacturerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "manufacturerName", $$v)
                                },
                                expression: "isf.manufacturerName",
                              },
                            },
                            _vm._l(
                              _vm.manufacturerNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "consolidatorName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [_vm._v("Consolidator(拼柜地)")]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.consolidatorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "consolidatorName", $$v)
                                },
                                expression: "isf.consolidatorName",
                              },
                            },
                            _vm._l(
                              _vm.consolidatorNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "stuffingName" },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("div", { staticClass: "lable" }, [
                              _c("span", [
                                _vm._v("Container Staffing Location(装货地)"),
                              ]),
                            ]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.isf.stuffingName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isf, "stuffingName", $$v)
                                },
                                expression: "isf.stuffingName",
                              },
                            },
                            _vm._l(
                              _vm.stuffingNameOptions,
                              function (item, index) {
                                return _c(
                                  "el-option",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { float: "left" } },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.address
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.cityAddress
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.provinceEnName
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("formatStatusAddress")(
                                                item?.countryName
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              item?.postcode
                                                ? item?.postcode
                                                : ""
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "base-panel",
                {
                  staticClass: "panel",
                  attrs: {
                    title: "HS CODE列表",
                    height: "20px",
                    fontSize: "14px",
                  },
                },
                [
                  _c(
                    "ul",
                    [
                      _c("li", { staticClass: "header" }, [
                        _c("div", { staticClass: "cell1" }, [
                          _c("span", [_vm._v("* ")]),
                          _vm._v(" 海关编码(6位)"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "cell4", on: { click: _vm.addItems } },
                          [
                            _c("svg-icon", {
                              attrs: { iconClass: "add", className: "icon" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(_vm.isf.htsItems, function (item, $index) {
                        return _c("li", { key: $index }, [
                          _c(
                            "div",
                            { staticClass: "cell1" },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "6" },
                                model: {
                                  value: item.hsCode,
                                  callback: function ($$v) {
                                    _vm.$set(item, "hsCode", $$v)
                                  },
                                  expression: "item.hsCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "cell4",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItems($index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete icon" })]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "btn btn1", on: { click: _vm.cancel } }, [
              _vm._v("取消"),
            ]),
            _c("div", { staticClass: "btn btn3", on: { click: _vm.save } }, [
              _vm._v("存为模板"),
            ]),
            _c("div", { staticClass: "btn btn2", on: { click: _vm.ok } }, [
              _vm._v("确定"),
            ]),
          ]),
          _c("SaveIsfTplDialog", {
            attrs: { dialogVisible: _vm.dialogVisible1, isfTpl: _vm.isfTpl },
            on: {
              ok: function ($event) {
                _vm.dialogVisible1 = false
              },
              cancel: function ($event) {
                _vm.dialogVisible1 = false
              },
            },
          }),
          _c("SaveIsfTplListDialog", {
            attrs: { dialogVisible: _vm.dialogVisible2 },
            on: {
              ok: _vm.ok3,
              cancel: function ($event) {
                _vm.dialogVisible2 = false
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }